module.exports = __webpack_public_path__ + "img/02.6d8be97c.png";